import React from 'react'
import PropTypes from 'prop-types'

FileUploadIcon.propTypes = {
  className: PropTypes.string
}

export default function FileUploadIcon({ className = '' } = '') {
  return (
    <span className={`svg-icon svg-md-icon ${className}`}>
<svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.33366 1.33334L13.3337 5.33334V13.3333C13.3337 13.687 13.1932 14.0261 12.9431 14.2761C12.6931 14.5262 12.3539 14.6667 12.0003 14.6667H4.00033C3.6467 14.6667 3.30756 14.5262 3.05752 14.2761C2.80747 14.0261 2.66699 13.687 2.66699 13.3333V2.66667C2.66699 2.31305 2.80747 1.97391 3.05752 1.72386C3.30756 1.47381 3.6467 1.33334 4.00033 1.33334H9.33366ZM12.0003 13.3333V6H8.66699V2.66667H4.00033V13.3333H12.0003ZM8.00033 8L10.667 10.6667H9.00033V12.6667H7.00033V10.6667H5.33366L8.00033 8Z" fill="#BDBDBD"/>
</svg>
        </span>
  )
}
